<script setup>

import { inject } from 'vue';
import { getAppelApiGlisserDeplacer } from '@/scripts/gestionGlisserDeplacer.js';
import ElementRapport from '@/components/elementsRapport/ElementRapport.vue';

const { section } = defineProps({
	section: Object
});

const appelerApiModifModele = inject('appelerApiModifModele');
const trouverElementEtParent = inject('trouverElementEtParent');
const selectionnerElement = inject('selectionnerElement');

function activerSurvol() {
	section.survol = true;
}

function desactiverSurvol() {
	if (section.survol) {
		delete section.survol;
	}
}

function accueillirGlisserDeplacer(event) {
	desactiverSurvol();
	const appelApi = getAppelApiGlisserDeplacer(event, section, null);
	if (appelApi) {
		appelerApiModifModele(appelApi.api, appelApi.argument, (reponseOK) => {
			if (reponseOK) {
				const elementEtParent = trouverElementEtParent(section.positionSection, [section.elements.length - 1]);
				selectionnerElement(elementEtParent.element, elementEtParent.parent);
			}
		});		
	}
}

</script>

<template>
		<div class="contenu-section"
			:class="{survol: section.survol}"
			@dragenter.stop.prevent="activerSurvol()"
			@dragover.stop.prevent="activerSurvol()"
			@dragleave.stop.prevent="desactiverSurvol()"
			@drop.stop.prevent="accueillirGlisserDeplacer">
			<ElementRapport :element="section.titre" :parent="section" />
			<ElementRapport v-for="element in section.elements" :element="element" :parent="section" />
			<div class="sous-sections" v-if="section.sousSections.length > 0">
				<hr class="barre-horizontale">
				<label class="titre-sous-sections">Sous-sections :</label>
				<ElementRapport v-for="sousSection in section.sousSections" :element="sousSection" :parent="section" />
			</div>
		</div>
</template>

<style scoped>

.contenu-section {
	padding: 5px;
	padding-top: 10px; 
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	border-style: solid;
	border-width: 0px;
	height: 80vh;
	max-width: 100vw;
	overflow: auto;
}

.titre-sous-sections {
	font-size: large;
	text-decoration: underline;
	color: var(--couleur-primaire);
}

.barre-horizontale {
	color: var(--couleur-primaire);
	margin-top: 25px;
}

</style>